













import { Component, Prop, Vue } from 'vue-property-decorator'
import { getDateFormattedOutput, prepareDateToLocal, dayJsUtcDate } from '~/utils/dates'
import formatDateToNow from '~/utils/dates/formatDateToNow'

@Component
export default class DateOutput extends Vue {
  @Prop({
    type: [String, Date]
  })
  date: string | Date

  @Prop({
    type: String,
    default: 'shortLive'
  })
  format: 'shortLive' | 'date' | 'fullDate'

  // С постфиксом "назад" если коротка дата? Например, 5 ч назад
  @Prop({
    type: Boolean,
    default: false
  })
  withPostfix: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isAlreadyUtc: boolean

  displayedText: null | string = null

  intervalDate: null | NodeJS.Timeout = null

  created () {
    this.setDisplayedText()
  }

  mounted () {
    this.initFormatDistanceToNow()
  }

  beforeDestroy () {
    if (this.intervalDate && this.format === 'shortLive') clearInterval(this.intervalDate!)
  }

  get dateInstance () {
    if (this.isAlreadyUtc) {
      return dayJsUtcDate(this.date)
    }

    if (typeof this.date === 'string') {
      return prepareDateToLocal(this.date)
    }

    return this.$dayjs(this.date)
  }

  get tooltip () {
    return this.dateInstance.format('DD.MM.YYYY HH:mm:ss')
  }

  initFormatDistanceToNow () {
    this.setDisplayedText()

    const isTimeoutInterval = this.$dayjs().diff(this.dateInstance, 'm') <= 2
    if (this.format === 'shortLive' && isTimeoutInterval) {
      this.intervalDate = setInterval(this.setDisplayedText, 1000)
    }
  }

  setDisplayedText () {
    // Иногда приходит "0000-00-00 00:00:00" дата с бэкенда, и тогла dateInstance имеет год 1899
    if (
      (typeof this.date === 'string' && this.date === '0000-00-00 00:00:00') ||
      this.dateInstance.year() < 1900
    ) {
      this.displayedText = 'очень давно'

      return
    }

    this.displayedText = this.format === 'shortLive'
      ? formatDateToNow(this.dateInstance, {
        withSuffix: this.withPostfix,
        cutUnit: !this.withPostfix
      })
      : getDateFormattedOutput(this.dateInstance, {
        format: this.format
      })

    if (this.format === 'shortLive' && this.$dayjs().diff(this.dateInstance, 'm') > 2) {
      clearInterval(this.intervalDate!)
    }
  }
}
